import axios from '@shared/axios-shared';

export const getSchedule = (id, school_id, page) => {
	return axios.get(`api/v1/school/rooms/schedule/list?room_id=${id}&school_id=${school_id}&page=${page}`);
};

export const addSchedule = (data) => {
	return axios.post(`api/v1/school/rooms/schedule/add`, data);
};

export const uploadSchedule = (data) => {
	return axios.post(`/api/v2/room/schedule/upload`, data);
};

export const deleteSchedule = (id) => {
	return axios.delete(`api/v1/school/rooms/schedule/delete/${id}`);
};

export const updateschedule = (data, id) => {
	return axios.put(`/api/v1/school/rooms/schedule/update/${id}`, data);
};
